import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "redux/store";

interface IcaiState {
  icai_is_connected: boolean;
}

const initialState: IcaiState = {
  icai_is_connected: false,
};

const icaiSlice = createSlice({
  name: "icai",
  initialState,
  reducers: {
    setIcaiConnected(state, action: PayloadAction<boolean>) {
      state.icai_is_connected = action.payload;
    },
  },
});

export const selectIcaiConnected = (state: RootState) => state.icai.icai_is_connected;
export const { setIcaiConnected } = icaiSlice.actions;
export default icaiSlice.reducer;
